import { Form, Modal } from 'antd';
import React, { useState } from 'react';
import ScopeCreateForm from '../../../components/domain/Scopes/ScopeCreateForm';
import type { ScopeCreateFormValues } from '../../../components/domain/Scopes/ScopeCreateForm';
import { getRequestErrorMessage } from '../../../lib/utils/getRequestErrorMessage';

interface ScopeCreateModalProps {
  description?: React.ReactNode;
  isSaving: boolean;
  onClose: () => void;
  onCreate: (name: string) => Promise<void>;
}

const ScopeCreateModal: React.FC<ScopeCreateModalProps> = ({
  description,
  isSaving,
  onClose,
  onCreate,
}) => {
  const [form] = Form.useForm<ScopeCreateFormValues>();
  const [submitError, setSubmitError] = useState<string>();

  const submit = async (values: ScopeCreateFormValues) => {
    try {
      setSubmitError(undefined);
      await onCreate(values.name.trim());
    } catch (error) {
      setSubmitError(getRequestErrorMessage(error, 'The Scope could not be created.'));
    }
  };

  return (
    <Modal
      cancelButtonProps={{ disabled: isSaving }}
      confirmLoading={isSaving}
      maskClosable={false}
      okText="Create"
      open={true}
      title="Create Scope"
      onCancel={onClose}
      onOk={() => form.submit()}
    >
      <ScopeCreateForm
        autoFocus
        description={description}
        error={submitError}
        form={form}
        onSubmit={name => submit({ name })}
      />
    </Modal>
  );
};

export default ScopeCreateModal;
